import { OrganizationType } from "@covertree/new-business-graphql";

export const organizationTypeOption: {
  value: OrganizationType;
  label: string;
}[] = [
  {
    label: "Estate",
    value: OrganizationType.Estate,
  },
  {
    label: "Trust",
    value: OrganizationType.Trust,
  },
  {
    label: "LLC",
    value: OrganizationType.Llc,
  },
  {
    label: "LLP",
    value: OrganizationType.Llp,
  },
  {
    label: "Partnership",
    value: OrganizationType.Partnership,
  },
  {
    label: "Corporation",
    value: OrganizationType.Corporation,
  },
  {
    label: "Not Listed",
    value: OrganizationType.NotListed,
  },
];
